/* eslint-disable arrow-body-style */
import * as qs from "query-string";
import axiosClient from "../client";
import { MEDIA_API_ROUTES } from "./constants";

export class MediaAPIService {
  constructor() {
    this.client = axiosClient;
  }

  getUploadUrl = async ({ queryParams }) => {
    return this.client.get(
      `${MEDIA_API_ROUTES.GET_UPLOAD_URL}?${qs.stringify(queryParams)}`
    );
  };

  getSignedUrl = async ({ body }) => {
    return this.client.post(MEDIA_API_ROUTES.GET_SIGNED_URL, body);
  };
}
